import {AdditionalPACData, PaymentFrequency} from '../../models/additional-pac-data.model';

export function getDefaultPaymentAmount(pacDetails: AdditionalPACData): number {
  const isInstallment = pacDetails?.paymentFrequency === PaymentFrequency.I;
  const payable = isInstallment
    ? pacDetails?.selectedAmountPayable ?? 0
    : pacDetails?.balancePayable ?? 0 ;
  const amountPaid = pacDetails?.amountPaid ?? 0;
  if (amountPaid > 0 && isInstallment) {
    return payable - amountPaid;
  }
  return payable;
}

export function restrictToTwoDecimals(event: Event): string {
  const input = event.target as HTMLInputElement;
  let value = input.value.replaceAll(/[^0-9.]/g, '');
  const parts = value.split('.');
  if (parts.length > 2) {
    value = parts[0] + '.' + parts[1];
  }
  if (parts[1]?.length > 2) {
    value = parts[0] + '.' + parts[1].substring(0, 2);
  }
  input.value = value;
  return value;
}

